import * as Yup from "yup";
export const Auth0Schema = Yup.object({
    AUTH0_CLIENT_ID: Yup.string().required(),
    AUTH0_DOMAIN: Yup.string().required(),
    AUTH0_AUDIENCE: Yup.string().required(),
    AUTH0_GOOGLE_CONNECTION: Yup.string().optional(),
    AUTH0_DB_CONNECTION: Yup.string().required(),
});
export function getAuth0Config(env) {
    var _a;
    const OR_HOSTNAME = ((_a = env.REACT_APP_OR_HOSTNAME) === null || _a === void 0 ? void 0 : _a.split(",")) || [];
    if (OR_HOSTNAME.some((hostname) => hostname.includes(window.location.hostname) ||
        window.location.hostname.includes(hostname))) {
        return {
            AUTH0_CLIENT_ID: env.REACT_APP_OR_AUTH0_CLIENT_ID || "",
            AUTH0_DOMAIN: env.REACT_APP_OR_AUTH0_DOMAIN || "",
            AUTH0_AUDIENCE: env.REACT_APP_OR_AUTH0_AUDIENCE || "",
            AUTH0_GOOGLE_CONNECTION: env.REACT_APP_OR_AUTH0_GOOGLE_CONNECTION || "",
            AUTH0_DB_CONNECTION: env.REACT_APP_OR_AUTH0_DB_CONNECTION || "",
        };
    }
    return {
        AUTH0_CLIENT_ID: env.REACT_APP_AUTH0_CLIENT_ID,
        AUTH0_DOMAIN: env.REACT_APP_AUTH0_DOMAIN,
        AUTH0_AUDIENCE: env.REACT_APP_AUTH0_AUDIENCE,
        AUTH0_GOOGLE_CONNECTION: env.REACT_APP_AUTH0_GOOGLE_CONNECTION,
        AUTH0_DB_CONNECTION: env.REACT_APP_AUTH0_DB_CONNECTION,
    };
}
//# sourceMappingURL=auth0.js.map